const BubbleInfo = () => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0015 2L4.00146 2.00001C2.89689 2.00002 2.00146 2.89545 2.00146 4.00001V10.6905C2.00146 11.7951 2.8969 12.6905 4.00146 12.6905H5.76788L7.57035 14.2014C7.81699 14.4082 8.17611 14.4092 8.42393 14.2039L10.2506 12.6905L12.0015 12.6905C13.106 12.6905 14.0015 11.7951 14.0015 10.6905V4C14.0015 2.89543 13.106 2 12.0015 2ZM8 9.83333C8.36819 9.83333 8.66667 9.53486 8.66667 9.16667V7.83333C8.66667 7.46514 8.36819 7.16667 8 7.16667C7.63181 7.16667 7.33333 7.46514 7.33333 7.83333V9.16667C7.33333 9.53486 7.63181 9.83333 8 9.83333ZM8 6.66667C7.53976 6.66667 7.16667 6.29357 7.16667 5.83333C7.16667 5.3731 7.53976 5 8 5C8.46024 5 8.83333 5.3731 8.83333 5.83333C8.83333 6.29357 8.46024 6.66667 8 6.66667Z"
      fill="currentColor"
    />
  </svg>
)

export default BubbleInfo
